import React, {useEffect, useRef, useState} from 'react';
import {Sidebar} from "primereact/sidebar";
import {useTranslate} from "../../../system/useTranslate";
import {ProgressBar} from "primereact/progressbar";
import Avatar from "../../../system/components/avatar";
import Icon from "../../../system/components/icon";
import {Button} from "primereact/button";
import {DataView} from "primereact/dataview";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useGoal} from "../../../models/goal/use-goal";
import {useProject} from "../../../models/project/use-project";
import {setWorkspaceMembership} from "../../../system/app-slice";
import BoxHeader from "../../components/box-header";
// import {Menu} from "primereact/menu";
import ProjectsListDialog from "../../goals/components/projects-list-dialog";
import GoalsListDialog from "../../goals/components/goals-list-dialog";

function ProjectSidebar({projectData, setProjectData, onHide,updateProject, disabled}) {
    const translate = useTranslate();
    const navigate = useNavigate();
    const project = useProject();
    const {user} = useSelector(state => state.auth);
    // const moreMenu = useRef(null);
    // const moreMenuItems = [
    //     {label:translate("delete"), command:()=>{updateProject(projectData.id, {archivedAt:new Date(), archivedBy:user.id})
    //             console.log("clicked");
    //
    //             setProjectData(undefined)
    //             onHide?.()
    //     }}
    // ]

    return (
        <Sidebar showCloseIcon={false} className="w-3 rtl surface-50 text-xs headerless-sidebar" visible={projectData!==undefined} onHide={()=>{setProjectData(undefined); onHide?.()}} pt={{content: () => ({style: {padding: 0}})}}>
            <div className={`flex flex-column gap-2 h-full `}>
                <div className=" bg-red-100 border-bottom-1 border-200 flex align-items-center justify-content-between p-2">
                    <div className="flex align-items-center gap-2">
                        <Icon icon="mi mi:close" onClick={()=>{setProjectData(undefined)}}/>
                        <span className="font-bold">{projectData?.title}</span>
                    </div>
                    <span className={project.statusClassName(projectData?.projectStatus, true, true)}>{translate(projectData?.projectStatus)}</span>
                </div>
                {/*<Icon icon="mi mi:more_horiz"  onClick={(e)=>{moreMenu.current.toggle(e)}}/>*/}
                {/*<Menu pt={{root:()=>({className:"w-fit p-1 "}), menuitem:()=>({className:"text-sm rtl"})}} model={moreMenuItems} popup ref={moreMenu} />*/}


                <div className={`flex flex-column gap-3 flex-1 p-3 ${disabled && " p-disabled"}`}>

                    <ProjectStatus projectData={projectData}/>

                    <CardView className="bg-white border-1 border-200">
                        <ZofinoProgressBar value={50} label={translate("overall-progress")}/>
                    </CardView>

                    <CardView className="bg-white border-1 border-200">
                        <LinkedGoals projectData={projectData}/>
                    </CardView>

                    <CardView className="bg-white border-1 border-200">
                        <LinkedProjects projectData={projectData}/>
                    </CardView>
                </div>
                <div className="p-3">
                    <Button disabled={disabled} onClick={()=>{navigate(`/projects/${projectData?.documentId}`)}} className="w-full border-round-lg text-xs p-2" icon={<Icon icon="mi mi:open_in_new"/>} label={translate("show-goal")}/>
                </div>
            </div>
        </Sidebar>
    );
}

function ProjectStatus({projectData}) {
    const translate = useTranslate();

    const ItemTemplate = (data)=>{
        return(
            <div className="w-6 text-xs py-2">
                {data.render}
            </div>
        )
    }

    const cards = [
        {
            className: "flex align-items-center justify-content-center",
            render:(
                <div className="flex flex-column justify-content-center">
                    <span>{translate("project-owner")}</span>
                    <div className="flex align-items-center gap-2">
                        <Avatar memberData={projectData?.owner?.member} className="text-3xs" style={{width:"1.55rem", height:"1.55rem"}}/>
                        <span className="font-bold text-2xs">{projectData?.owner?.member?.fullname}</span>
                    </div>
                </div>
            )

        },
        {
            className: "flex align-items-center justify-content-center",
            render:(
                <div className="flex flex-column justify-content-center">
                    <span>{translate("team")}</span>
                    <span className="font-bold">{""}</span>
                </div>
            )

        },
        {
            className: "flex align-items-center justify-content-center",
            render:(
                <div className="flex flex-column justify-content-center">
                    <span>{translate("schedule")}</span>
                    <span className="font-bold">{""}</span>
                </div>
            )

        }
    ]

    return(
        <CardView className="bg-white border-1 border-200 p-3 flex flex-column gap-2">
            <div className="w-full flex justify-content-between align-items-center">
                <span>{translate("key-info")}</span>
            </div>
            <DataView itemTemplate={ItemTemplate} layout="grid" value={cards}/>
        </CardView>
    )
}

function ZofinoProgressBar({value, label}) {
    return(
        <div className="flex flex-column p-3">
            <div className="flex justify-content-between align-items-center p-1 font-bold text-400">
                <span>{label}</span>
                <span>{value}%</span>
            </div>
            <ProgressBar showValue={false} style={{ height: '10px' }} value={value}/>
        </div>
    )
}

function LinkedProjects({projectData}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const dispatch = useDispatch();
    const [projectsDialogVisible, setProjectsDialogVisible] = useState(false);
    const translate = useTranslate();
    const [projectsStats, setProjectsStats] = useState([])
    const goal = useGoal();
    const project = useProject();
    const ItemTemplate = (data)=>{
        return (
            <div className="w-full text-xs py-1">
                <div className="p-2 w-full border-round surface-100 flex flex-column gap-2">
                    <div className="flex justify-content-between">
                        <span>{data.title}</span>
                        <span className={project.statusClassName(data.projectStatus, true , true)}>{translate(data.projectStatus)}</span>
                    </div>
                    <ProgressBar className="w-full h-1rem text-2xs" showValue={true} value={data.progress.value}/>
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (projectData){
            getLinkedProjects()
        }
    }, [projectData]);

    const getLinkedProjects = async ()=>{
        let _data = await project.getProjectsProgress({goals:{$in:[projectData?.id]}});
        setProjectsStats(_data);
    }

    return(
        <div>
            <div className="p-3 flex flex-column gap-2">
                <BoxHeader title={translate("linked-projects")} />
                <DataView emptyMessage={<span className="text-xs text-300">{translate("project-no-projects-linked")}</span>} itemTemplate={ItemTemplate} layout="list" value={projectsStats}/>
            </div>
        </div>
    )
}

function LinkedGoals({projectData}) {
    const [goalsDialogVisible, setGoalsDialogVisible] = useState(false);
    const translate = useTranslate();
    const goal = useGoal();
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const ItemTemplate = (data)=>{
        return (
            <div className="w-full text-xs py-1">
                <div className="p-2 w-full border-round surface-100 flex justify-content-between align-items-center">
                    <div className="flex flex-column">
                        <span>{data?.title}</span>
                    </div>
                    <Button onClick={()=>{navigate(`/goals/${data.id}`)}} pt={{label:()=>({className:"font-normal text-2xs"})}} className="text-xs w-2 border-1 p-button-info p-button-outlined px-2 p-1" label={translate("show-goal")}/>
                </div>
            </div>
        )
    }


    return(
        <div>
            <div className="p-3 flex flex-column gap-2 ">
                <BoxHeader title={translate("parent-goals")}/>
                <DataView emptyMessage={<span className="text-xs text-300">{translate("goal-no-link")}</span>} itemTemplate={ItemTemplate} layout="list" value={projectData?.goals}/>
            </div>
        </div>
    )
}

function DataCard({label, children, className = "h-5rem"}) {
    return(
        <div className={`w-full text-xs ${className}`}>
            <div className="surface-100 border-round-2xl flex flex-column gap-2 p-2 h-full">
                {label&&<span className="font-bold text-400">{label}</span>}
                <div className="flex-1">
                    {children}
                </div>
            </div>
        </div>
    )
}

function CardView ({children, className}){
    return (
        <div className={`${className} text-xs w-full border-round-xl`}>
            {children}
        </div>
    )
}

export default ProjectSidebar;
